<template>
    <div>
        <div class="row mb-0 rooms-advanced-search">
            <FormDynamic  
            :form_format="form_format"
            :form_data="form_data"
            :array_options="array_options"
            :content_align_x="'rooms-advanced-search'"
            name="form"
            >
                <template v-slot:more-fields>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Description:" class="modal-label" v-html="'Description:'"/>
                            <input  type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'description'})">
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="customdescription?:" class="modal-label" v-html="'Custom Description:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.custom_description">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="seconddescription?:" class="modal-label" v-html="'Second Description:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.second_description">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Room type:" class="modal-label" v-html="'Room type:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.room_type_id">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in array_options.room_type_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Floor Type:" class="modal-label" v-html="'Floor type:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.floor_id">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in array_options.floor_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="CostCenter:" class="modal-label" v-html="'Cost center:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.cost_center_id">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in array_options.cost_center_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Closed?:" class="modal-label" v-html="'Closed?:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.closed">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for=":" class="modal-label" v-html="'Door Number:'"/>
                            <input type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'door_number'})">
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 pl-2 py-0">
                        <div class="row mb-0">
                            <div class="col-md-3 py-0">
                                <div class="formdynamic__item__field">
                                    <label for="Fixtures/Beds:" class="modal-label" v-html="'Fixtures/Beds:'"/>
                                    <select size="" class="input-field custom-select" v-model="form_data.fixture_simbol">
                                        <!-- <option value="" v-html="'Select an option'"/> -->
                                        <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-9 py-0">
                                <div class="formdynamic__item__field">
                                    <label class="modal-label invisible" v-html="'Fixtures/Beds:'"/>
                                    <input type="number" :min="0" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'fixtures'})"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 pl-2 py-0">
                        <div class="row mb-0">
                            <div class="col-md-3 py-0">
                                <div class="formdynamic__item__field">
                                    <label for="SQ/FT:" class="modal-label" v-html="'SQ/FT:'"/>
                                    <select size="" class="input-field custom-select" v-model="form_data.sq_ft_simbol">
                                        <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-9 py-0">
                                <div class="formdynamic__item__field">
                                    <label class="modal-label invisible" v-html="'SQ/FT:'"/>
                                    <input type="number" :min="0" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'sq_ft'})"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="essential_cleaning:" class="modal-label" v-html="'Essential cleaning:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.essential_cleaning">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="WorkGroup" class="modal-label" v-html="'Work Group:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.work_group">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in array_options.group_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Excl. Dailys" class="modal-label" v-html="'Excl. Dailys:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.exclude_daily">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in excl_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Excl. Projects" class="modal-label" v-html="'Excl. Projects:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.exclude_project">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in excl_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="PatientRoom:" class="modal-label" v-html="'Patient room:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.patient">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Comment:" class="modal-label" v-html="'Comment:'"/>
                            <input type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'notes'})"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Disable Daily Updates" class="modal-label" v-html="'Disable Daily Updates:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.disabled_daily">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Disable Project Updates" class="modal-label" v-html="'Disable Project Updates:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.disabled_project">
                                <option value="" v-html="'Select an option'"/>
                                <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-auto py-0">
                        <div class="formdynamic__item__field">
                            <label for="Daily shift:" class="modal-label" v-html="'Daily shift: '"/>
                            <span class="d-flex">
                                <div class="pt-2">
                                    <label class="modal-label" v-html="'1'"/>
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'shift1'" type="checkbox" class="custom-control-input" v-model="form_data.shift1"/>
                                        <label :for="'shift1'" class="custom-control-label ml-2"/>
                                    </div>
                                </div>
                                <div class="pt-2">
                                    <label class="modal-label" v-html="'2'"/>
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'shift2'" type="checkbox" class="custom-control-input" v-model="form_data.shift2"/>
                                        <label :for="'shift2'" class="custom-control-label ml-2"/>
                                    </div>
                                </div>
                                <div class="pt-2">
                                    <label class="modal-label" v-html="'3'"/>
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'shift3'" type="checkbox" class="custom-control-input" v-model="form_data.shift3"/>
                                        <label :for="'shift3'" class="custom-control-label ml-2"/>
                                    </div>
                                </div>
                                <div class="pt-2">
                                    <label class="modal-label" v-html="'none'"/>
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'none'" type="checkbox" class="custom-control-input" v-model="form_data.none"/>
                                        <label :for="'none'" class="custom-control-label ml-2"/>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                    <!-- <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Shift Criteria" class="modal-label" v-html="'Shift Criteria:'"/>
                            <select size="" class="input-field custom-select">
                                <option value="" v-html="'Select an option'"/>
                            </select>
                        </div>
                    </div> -->
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="row mb-0">
                            <div class="col-md-4 py-0">
                                <div class="formdynamic__item__field">
                                    <label class="modal-label" v-html="'SinkMin:'"/>
                                    <select class="input-field custom-select" v-model="form_data.time_adjustment_simbol">
                                        <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-8 py-0">
                                <div class="formdynamic__item__field">
                                    <label class="modal-label invisible" v-html="'Sink:'"/>
                                    <input type="number" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'time_adjustment'})"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formdynamic__item col-auto py-0 rooms-advanced-search__radio-tasks" v-if="filter_options['daily'] !== false || filter_options['policing'] || false || filter_options['projects'] !== false">
                        <div class="formdynamic__item__field pl-2">
                            <template v-for="(value, i) in radio_options" >
                                <div :key="i" v-if="filter_options[value.ref] == undefined  || filter_options[value.ref] == true" :class="value.div_class">
                                    <input 
                                        :class="value.input_class"
                                        type="radio"
                                        :id="value.ref"
                                        name="radio"
                                        :value="value.ref"
                                        v-model="form_data.radio"
                                        :checked="i === radio_options.length - 1 ? true : false"
                                    />
                                    <label :for="value.ref" :class="'form-check-label radiobutton__text custom-control-label'" v-html="value.name"/>
                                </div>
                            </template> 
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Task:" class="modal-label" v-html="'Task:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.task_id" :disabled="form_data.radio ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option v-for="(item, i) in array_options.task_id" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-2 pl-2 py-0">
                        <div class="row mb-0">
                            <div class="col-md-3 py-0" v-if="form_data.radio != 'projects'">
                                <div class="formdynamic__item__field">
                                    <label for="Frequency:" class="modal-label" v-html="'Frequency:'"/>
                                    <select size="" class="input-field custom-select" v-model="form_data.freq_simbol" :disabled="form_data.radio ? false : true">
                                        <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-9 py-0">
                                <div class="formdynamic__item__field">
                                    <label class="modal-label" :class="form_data.radio != 'projects' ? 'invisible' : ''" v-html="'Frequency:'"/>
                                    <select size="" class="input-field custom-select" v-model="form_data.frequency" v-if="form_data.radio == 'projects'" :disabled="form_data.radio ? false : true">
                                        <option value="" v-html="'Select an option'" />
                                        <option v-for="(item, i) in array_options['frequency_id']" :key="i" :value="item.id" v-html="item.name"/>
                                    </select>
                                    <input v-else type="number" :min="1" class="form-control" :value="form_data['frequency']" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'frequency'})" :disabled="form_data.radio ? false : true"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formdynamic__item col-auto py-0 rooms-advanced-search__radio-assignation" v-if="filter_options['show_rooms_that_are'] == undefined  || filter_options['show_rooms_that_are'] == true">
                        <div class="formdynamic__item__field">
                            
                            <label for="unassigned-rooms" class="modal-label" v-html="'Show rooms that are: '"/>
                            <div class="row mb-0 no-gutters ml-2">
                                <template v-for="(value, i) in radio_room_state_options" >
                                    <div :key="i" v-if="value" :class="value.div_class">
                                        <input 
                                            :class="value.input_class"
                                            type="radio"
                                            :id="value.ref"
                                            name="radio"
                                            :value="value.ref"
                                            v-model="form_data.show_rooms_that_are"
                                        />
                                        <label :for="value.ref" :class="'form-check-label radiobutton__text custom-control-label'" v-html="value.name"/>
                                    </div>
                                </template> 
                            </div>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-auto py-0" v-if="filter_options['show_properly_assigned_rooms'] == undefined  || filter_options['show_properly_assigned_rooms'] == true">
                        <div class="formdynamic__item__field">
                            <label for="properly-assigned-rooms" class="modal-label" v-html="'Show properly assigned rooms: '"/>
                            <span class="d-flex mt-2">
                                <div class="pt-2">
                                    <label class="modal-label" v-html="'Yes'"/>
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'properly-assigned-rooms'" type="checkbox" class="custom-control-input" v-model="form_data.show_properly_assigned_rooms" :disabled="form_data.show_rooms_that_are && form_data.show_rooms_that_are != 'none_room_state'"/>
                                        <label :for="'properly-assigned-rooms'" class="custom-control-label ml-2"/>
                                    </div>
                                </div>
                                
                            </span>
                        </div>
                    </div>
                </template>
            </FormDynamic>
        </div>
        <div class="mt-3 d-flex align-items-center justify-content-center">
            <button style="width: 220px !important;" class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Search'" type="button" @click="$emit('resetList', {})" @keyup.enter="$emit('resetList', {})"/>
        </div>
    </div>
</template>

<script>

import FormDynamic  from '@/components/FormDynamic.vue';

export default {
    name: 'LocalFormSearch',

    components: 
    {
        FormDynamic,
    },

    props:[
        'form_data',
        'form_format',
        'array_options',
        'boolean_options',
        'radio_options',
        'radio_room_state_options',
        'simbol_options',
        'excl_options',
        'filter_options'
    ],

    mounted() 
    {
        window.addEventListener('keydown', this.handleEnterKey);
    },
    beforeDestroy() 
    {
        window.removeEventListener('keydown', this.handleEnterKey);
    },

    methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.$emit('resetList', {})
      }
    },
  }



}

</script>